import Symbol from "./Symbol";
import { INSPECTOR_TEXT_BOX } from "../../../constants/inspectorConstants";

class TextBoxSymbol extends Symbol {
  constructor({ alias, label }) {
    super("TextBox", {
      alias,
      svgSrc: null,
      label,
      rotable: false,
      handles: [],
    });

    this.attributes = {
      ...this.attributes,
      textContent: {
        isVisible: true,
        value: "Agrega texto en el inspector",
        label: "Contenido",
      },
      backgroundColor: {
        isVisible: true,
        value: "#FFFFFF",
        label: "Color de fondo",
      },
      backgroundAlpha: {
        isVisible: false,
        value: 0,
        label: "Transparencia de fondo",
        systemDefined: true,
      },
      textColor: {
        isVisible: true,
        value: "#111827",
        label: "Color del texto",
      },
      textAlign: {
        isVisible: false,
        value: "center",
        label: "Alineación",
        systemDefined: true,
      },
      textBold: {
        isVisible: false,
        value: false,
        label: "Bold",
        systemDefined: true,
      },
    };
  }

  getInspector() {
    return INSPECTOR_TEXT_BOX;
  }
}

export default TextBoxSymbol;
